import React, { useEffect, useState } from "react";
import { APPLICATION_NAME, removeEmptyObjectKey, SOCKET_CHANNEL, SOCKET_URL } from "src/_config";
import { RodeoTvImageComponent } from "src/components/tv-image/tv-image-page";
import { RodeoNewTvImageComponent } from "src/components/tv-image/tv-image-page-new";
import useSocket from "use-socket.io-client";
import { useEventApi } from "src/_common/hooks/actions/event/appEventApiHook";
import { useParams } from "react-router";

export default function RodeoTvImageContainer() {
  const eventApi = useEventApi();
  const { gameId } = useParams<any>();

  const [site, setSite] = useState<any>("rodeo-pick");
  const [globalTvData, setGlobalTvData] = useState<any>();
  const [socketChannel, setSocketChannel] = useState<any>();
  const [rodeoEventId, setRodeoEventId] = useState<any>();

  const getTvImageDetails = (screen1: string, type: any) => {
    // let reId = localStorage.getItem("rodeoEventId");
    const params = {
      screen1,
      type,
    };
    eventApi.callTvImageDetails(
      removeEmptyObjectKey(params),
      (message: string, resp: any) => {
        console.log({ resp });
        // if (!reId) {
        //   localStorage.setItem("rodeoEventId", resp?.rodeo_event_dtls?.id);
        // }
        if (resp.rodeo_event_game_info.rp_is_fan_favrouite == 1) {
          setSite("fan-favorite");
        } else {
          setSite("rodeo-pick");
          setRodeoEventId(resp?.rodeo_event_dtls?.id);
        }
      },
      (message: string) => {
        console.error(`Error at API Access => ${message}`);
      }
    );
  };

  const setSiteDataChannelValues = (site: any, data: any, channel: any) => {
    setSite(site);
    setGlobalTvData(data);
    setSocketChannel(channel);
  };

  useEffect(() => {
    getTvImageDetails(gameId, null);
    const prevTitle = document.title;
    document.title = `${APPLICATION_NAME} : TV Leaderboard`;
    return () => {
      document.title = prevTitle;
    };
  }, []);

  //Socket Implementation start here
  const [socket] = useSocket(SOCKET_URL, {
    autoConnect: false,
  });

  useEffect(() => {
    socket.connect();

    Object.values(SOCKET_CHANNEL).map((item: any) =>
      socket.on(item, (data: any) => {
        // console.log(data)
        if (data?.rp_is_fan_favrouite == 1) {
          setSiteDataChannelValues("fan-favorite", data, item);
        } else {
          setSiteDataChannelValues("rodeo-pick", data, item);
        }
      })
    );

    return () => {
      socket.disconnect();
    };
  }, []);

  return (
    <React.Fragment>
      {site == "rodeo-pick" && rodeoEventId && (
        <RodeoTvImageComponent
          globalTvData={globalTvData}
          socketChannel={socketChannel}
          setGlobalTvData={setGlobalTvData}
          setSocketChannel={setSocketChannel}
          rodeoEventId={rodeoEventId}
        />
      )}

      {site == "fan-favorite" && (
        <RodeoNewTvImageComponent
          globalTvData={globalTvData}
          socketChannel={socketChannel}
          setGlobalTvData={setGlobalTvData}
          setSocketChannel={setSocketChannel}
        />
      )}
      {/* <RodeoTvImageComponent />
            <RodeoNewTvImageComponent /> */}
    </React.Fragment>
  );
}
